import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

interface BreadcrumbProps {
  breadcrumbItem: string;
  title: string;
}

const Breadcrumb = ({ breadcrumbItem, title }: BreadcrumbProps) => {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h2 className="mb-0 font-size-24">{breadcrumbItem}</h2>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to={`/${title}`}>{title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                {/* <Link to={`/${breadcrumbItem}`}>{breadcrumbItem}</Link> */}
                <span>{breadcrumbItem}</span>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
